import React, { useState } from "react";
import Panel from "../components/Panel";
import WardCard from "../components/WardCard";
import AddWardModal from "../components/AddWardModal";
import { FaPlus, FaHospital } from "react-icons/fa";

// Dummy data for initial wards
const dummyWards = [
  {
    id: 1,
    wardName: "Cardiology",
    department: "Medical",
    rooms: [
      {
        id: 101,
        number: "101A",
        type: "Standard",
        beds: [{ id: 1 }, { id: 2 }],
      },
      {
        id: 102,
        number: "101B",
        type: "Deluxe",
        beds: [{ id: 3 }, { id: 4 }],
      },
    ],
  },
  // More wards can be added here...
];

const WardSetup = () => {
  const [wards, setWards] = useState(dummyWards);
  const [showAddWardModal, setShowAddWardModal] = useState(false);

  // Handler to add a new ward from the modal
  const handleAddWard = (newWard) => {
    setWards([...wards, newWard]);
  };

  return (
    <Panel title="Ward Setup">
      <div className="flex justify-end mb-4">
        <button
          onClick={() => setShowAddWardModal(true)}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition flex items-center"
        >
          <FaPlus className="mr-2" /> Add New Ward
        </button>
      </div>

      {/* Ward List */}
      <div>
        <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
          <FaHospital className="mr-2 text-blue-900" /> Ward List
        </h3>
        {wards.length === 0 ? (
          <p className="text-gray-600">No wards available.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {wards.map((ward) => (
              <WardCard key={ward.id} ward={ward} />
            ))}
          </div>
        )}
      </div>

      {/* Add Ward Modal */}
      <AddWardModal
        isOpen={showAddWardModal}
        onClose={() => setShowAddWardModal(false)}
        onSave={handleAddWard}
      />
    </Panel>
  );
};

export default WardSetup;
